import { useTranslation } from 'react-i18next';

export type SupportedLanguages = "pt-BR" | "pt-PT" | "en-US" | "es-ES" | "fr-FR";

export const useI18n = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (language: SupportedLanguages) => {
    i18n.changeLanguage(language);
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const getAvailableLanguages: () => { code: SupportedLanguages; name: string }[] = () => {
    return [
      { code: 'pt-BR', name: 'Português (Brasil)' },
      { code: 'pt-PT', name: 'Português (Portugal)' },
      { code: 'en-US', name: 'English (US)' },
      // { code: 'fr-FR', name: 'Français (France)' },
      { code: 'es-ES', name: 'Español (España)' },
    ];
  };

  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
    currentLanguage: i18n.language,
  };
};

export default useI18n;
